const jacksonData = {
    "segmentDev": "7Pr2MLpHLRGzMaPTVuH7df5IO0XDUJxg",
    "segmentProd": "BwB6D2B2xoFovj9pHGt0JLRwzpAU8Evc"
};

export default jacksonData;